import { directMessageCounterpartId } from 'lib/directMessages'
import { getCachedUser } from 'state/cache'
import { subscribeToCachedEntity } from 'state/entityCacheSubscriptions'

type DirectMessageQuest = Parameters<typeof directMessageCounterpartId>[0]
type ViewerId = Parameters<typeof directMessageCounterpartId>[1]

// A direct message's composer names the other person. Undefined outside a
// direct message, so the composer keeps its own placeholder.
export function directMessageComposerPlaceholder(quest: DirectMessageQuest, viewerId: ViewerId) {
    const counterpartId = directMessageCounterpartId(quest, viewerId)
    if (!counterpartId) return undefined

    const counterpart = getCachedUser(counterpartId)
    const name = counterpart?.username || counterpart?.name
    return name ? `Message @${name}` : 'Write a message'
}

// The other person's record can reach the user cache after the thread renders:
// a new conversation has no message from them to carry it, so it lands when the
// head fetches them. The thread follows that entry to put their name in.
export function subscribeToDirectMessageCounterpart(
    quest: DirectMessageQuest,
    viewerId: ViewerId,
    listener: () => void,
) {
    const counterpartId = directMessageCounterpartId(quest, viewerId)
    return subscribeToCachedEntity('userNorm', counterpartId, listener)
}
